import BaseModel from './base_model';

// App.Models.Brand
export default BaseModel.extend();
